import {ErrorBase} from "@/rawdogjs/src/core/ErrorBase";

export class AlertService {
    // expand as needed
    public alert(message: string) {

        console.log(message);

        alert(message);

    }

    public alertErrors(errors: ErrorBase[]) {
        if (errors.length < 1)
            return;

        let list: string;

        for (const error of errors) {
            list += error.message + '\n';
        }

        this.alert(list);
    }


}